import MoveEntityDialog from './MoveEntityDialog';

export default MoveEntityDialog;
